<template>
  <div>
    <el-dialog
      title="开通会员"
      :visible.sync="visible"
      width="900px"
      :before-close="handleClose"
      :close-on-click-modal="false"
      custom-class="vip-dialog"
    >
      <template slot="title">
        <div class="vip-title">
          <template v-if="identity.viplevel > 0 && !isExpired">
            <div class="title-container">
              <div class="title">升级会员</div>
              <template v-if="currentLevelValue === identity.viplevel">
                <div class="subtitle">您是{{identity.name}}会员等级，有效期至:{{timestamp(identity.limittime)}}，下单延续会员时长</div>
              </template>
              <template v-else-if="currentLevelValue > identity.viplevel">
                <div class="subtitle">您是{{identity.name}}会员等级，有效期至:{{timestamp(identity.limittime)}}，下单升级会员等级</div>
              </template>
              <template v-else>
                <div class="subtitle">您是{{identity.name}}会员等级，有效期至:{{timestamp(identity.limittime)}}</div>
              </template>
            </div>
          </template>
          <template v-else>
            <div class="title-container">
              <div class="title">开通会员</div>
              <div class="subtitle">享受更多会员权益</div>
            </div>
          </template>
        </div>
      </template>
      
      <!-- Tab切换 -->
      <div class="tab-switcher">
        <div class="tab-item" 
             :class="{ active: activeTab === 'vip' }"
             @click="switchTab('vip')">
          <i class="el-icon-star-on"></i>
          会员开通
        </div>
        <div class="tab-item" 
             :class="{ active: activeTab === 'recharge' }"
             @click="switchTab('recharge')">
          <i class="el-icon-coin"></i>
          点数充值
        </div>
      </div>

      <!-- 会员开通Tab内容 -->
      <div v-show="activeTab === 'vip'" class="tab-content">
        <div class="vip-container">
          <!-- 付费周期选择 -->
          <div class="payment-cycle">
            <div class="cycle-title">选择付费周期</div>
            <div class="cycle-options">
              <div 
                class="cycle-option" 
                :class="{ active: paymentCycle === 'monthly' }"
                @click="selectPaymentCycle('monthly')"
              >
                <span>按月付费</span>
              </div>
              <div 
                class="cycle-option" 
                :class="{ active: paymentCycle === 'yearly' }"
                @click="selectPaymentCycle('yearly')"
              >
                <span>按年付费</span>
              </div>
            </div>
          </div>
          
          <!-- 会员等级选择 -->
          <div class="vip-levels">
            <div
              v-for="level in availableVipLevels"
              :key="level.id"
              class="vip-level-card"
              :class="{ 
                active: selectedVipId === level.id,
                disabled: isCardDisabled(level)
              }"
              @click="selectLevel(level.id, level)"
            >
              <div class="level-header">{{ level.name }}</div>
              <div class="level-price">¥{{ level.price }}/{{ getTimeUnit(level) }}</div>
              <div class="level-features">
                <div v-for="(feature, fIndex) in level.features" :key="fIndex">
                  {{ feature }}
                </div>
              </div>
              <div v-if="showCurrentTag(level)" class="current-level-tag">当前尊享</div>
            </div>
          </div>

          <!-- 支付方式选择 -->
          <div class="payment-methods">
            <div class="payment-title">选择支付方式</div>
            <div class="payment-options">
              <div
                class="payment-option"
                :class="{ active: payMethod === 'alipay' }"
                @click="selectPayMethod('alipay')"
              >
                <img src="./alipay-icon.svg" alt="支付宝" />
              </div>
            </div>
          </div>

          <!-- 支付按钮 -->
          <div class="payment-action">
            <el-button 
              type="primary" 
              @click="handlePayment" 
              :loading="paying"
              :disabled="loading || availableVipLevels.length === 0 || !selectedVipId">
              立即支付 ¥{{ selectedLevelPrice }}
            </el-button>
          </div>
        </div>
      </div>

      <!-- 点数充值Tab内容 -->
      <div v-show="activeTab === 'recharge'" class="tab-content">
        <div class="recharge-container">
          <!-- 充值套餐选择 -->
          <div class="recharge-packages">
            <div
              v-for="item in rechargeList"
              :key="item.id"
              class="package-card"
              :class="{ active: selectedPackageId === item.id }"
              @click="selectPackage(item.id)"
            >
              <div class="level-header">{{ item.name }}</div>
              <div class="level-price">¥{{ item.price }}</div>
              <div class="level-features">
                <div v-for="(feature, fIndex) in item.features" :key="fIndex">
                  {{ feature }}
                </div>
              </div>
            </div>
          </div>

          <!-- 支付方式选择 -->
          <div class="payment-methods">
            <div class="payment-title">选择支付方式</div>
            <div class="payment-options">
              <div
                class="payment-option"
                :class="{ active: payMethod === 'alipay' }"
                @click="selectPayMethod('alipay')"
              >
                <img src="./alipay-icon.svg" alt="支付宝" />
              </div>
            </div>
          </div>

          <!-- 支付按钮 -->
          <div class="payment-action">
            <el-button 
              type="primary" 
              @click="handleRechargePayment" 
              :loading="paying"
              :disabled="loading || rechargeList.length === 0 || !selectedPackageId">
              立即支付 ¥{{ selectedPackagePrice }}
            </el-button>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 支付弹窗组件 -->
    <order-ali-pay
      :visible.sync="showPayDialog"
      :pay-url="payUrl"
      :order-id="orderId"
      @success="handlePaySuccess"
      @close="handlePayCancel"
    />
  </div>
</template>

<script>
// Psocket 组件
import Psocket from '@/components/Flash/PSocket'
// 通讯协议
import Protocol from '@/common/scripts/protocol.js'
// 工具类
import EUY from '@/common/scripts/euy.js'
import OrderAliPay from './OrderAliPay.vue'

export default {
  name: 'VipMember',
  components: {
    OrderAliPay
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    identity: {
      type: Object,
      default: () => ({})
    },
    teamId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      selectedVipId: '', // 默认选中标准版
      payMethod: 'alipay', // 默认支付宝支付
      paying: false,
      vipLevels: [], // 改为空数组，通过API获取
      currentLevelInfo: null,
      showPayDialog: false,
      payUrl: '',
      orderId: '', // 订单ID
      payStatusTimer: null, // 支付状态轮询定时器
      loading: false, // 添加加载状态
      paymentCycle: 'monthly', // 付费周期，默认按月付费
      // Tab切换相关
      activeTab: 'vip', // 'vip' 或 'recharge'
      // 充值相关数据
      rechargeList: [], // 充值套餐列表
      selectedPackageId: '', // 选中的充值套餐ID
    }
  },
  computed: {
    availableVipLevels() {
      // 首先按付费周期筛选
      const cycleFilteredLevels = this.vipLevels.filter(level => {
        // 价格为0的试用商品在所有付费周期中都显示
        if (level.price === 0) {
          return true;
        }
        
        // 按付费周期筛选付费商品
        if (this.paymentCycle === 'monthly') {
          return level.productValidType === 2; // 月度会员
        } else {
          return level.productValidType === 3; // 年度会员
        }
      });
      
      // 如果已经是会员且未过期，只显示大于等于当前等级的会员类型
      if (this.identity.viplevel > 0 && !this.isExpired) {
        return cycleFilteredLevels.filter(level => level.level >= this.identity.viplevel);
      }
      // 如果不是会员或已过期，显示所有会员类型
      return cycleFilteredLevels;
    },
    selectedLevelPrice() {
      const level = this.availableVipLevels.find(l => l.id === this.selectedVipId)
      return level ? level.price : 0
    },
    selectedPackagePrice() {
      const pkg = this.rechargeList.find(p => p.id === this.selectedPackageId)
      return pkg ? pkg.price : 0
    },
    isExpired() {
      return this.identity.limittime * 1000 < Date.now()
    },
    currentLevelValue() {
      const level = this.vipLevels.find(l => l.id === this.selectedVipId);
      return level ? level.level : 0;
    },
    currentLevelIndex() {
      if (!this.identity.viplevel) return -1;
      for (let i = this.vipLevels.length - 1; i >= 0; i--) {
        if (this.vipLevels[i].level == this.identity.viplevel) {
          return i;
        }
      }
      return -1;
    },
    isCardDisabled(level) {
      return (level) => {
        return false;
        // if (this.currentLevelIndex === -1) return false;
        // return this.vipLevels.indexOf(level) < this.currentLevelIndex;
      }
    },
    showCurrentTag() {
      return (level) => {
        if (this.currentLevelIndex === -1) return false;
        return this.vipLevels.indexOf(level) === this.currentLevelIndex;
      }
    }
  },
  watch: {
    visible(val) {
      if (val) {
        // 当弹窗显示时获取数据
        this.handleGetVipGoods()
        this.handleGetRechargeGoods()
        // 当弹窗显示时，设置付费周期为按月付费
        this.paymentCycle = 'monthly'
        // 默认显示会员开通Tab
        this.activeTab = 'vip'
      } else {
        // 当弹窗关闭时重置数据
        this.vipLevels = []
        this.selectedVipId = ''
        this.rechargeList = []
        this.selectedPackageId = ''
        this.payMethod = 'alipay'
        this.activeTab = 'vip'
        this.paying = false
        this.paymentVisible = false
        this.stopCheckPayStatus()
      }
    },
    availableVipLevels: {
      handler(newLevels) {
        if (newLevels.length > 0 && !this.selectedVipId) {
          this.selectedVipId = newLevels[0].id
        } else if (newLevels.length === 0) {
          this.selectedVipId = ''
        }
      },
      immediate: true
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false)
    },
    selectLevel(id, level) {
      if (this.isCardDisabled(level)) {
        return;
      }
      this.selectedVipId = id;
    },
    selectPayMethod(method) {
      this.payMethod = method
    },
    selectPaymentCycle(cycle) {
      this.paymentCycle = cycle
      // 当切换付费周期时，更新默认选中的会员等级
      if (this.availableVipLevels.length > 0) {
        this.selectedVipId = this.availableVipLevels[0].id
      } else {
        this.selectedVipId = ''
      }
    },
    switchTab(tab) {
      this.activeTab = tab
      if (tab === 'recharge') {
        // 切换到充值Tab时获取充值套餐数据
        this.handleGetRechargeGoods()
      }
    },
    selectPackage(id) {
      this.selectedPackageId = id
    },
    async handlePayment() {
      if (!this.selectedVipId) {
        this.$message.error('请选择会员等级')
        return
      }

      const selectedVip = this.vipLevels.find(item => item.id === this.selectedVipId)
      if (!selectedVip) {
        this.$message.error('无效的会员等级')
        return
      }

      this.handlePostCreateOrder(selectedVip.id)
    },
    async handleRechargePayment() {
      if (!this.selectedPackageId) {
        this.$message.warning('请选择充值套餐')
        return
      }
      this.paying = true
      this.handlePostCreateOrder(this.selectedPackageId)
    },

    // 生成订单
    handlePostCreateOrder(goodsId) {
      let URL = process.env.HOST + '/api/storage/order/createOrder'
      
      // 创建FormData对象
      const formData = new FormData()
      formData.append('goodsId', goodsId)

      let headers = {
        'Authorization': EUY.GetStorage('login_status').tokenId
      }
      
      this.AJAX.post(URL, headers, formData).then((res) => {
        if (res.code === 10000) {
          this.orderId = res.datas.orderId
          // 如果是免费试用版（status=2），直接处理支付成功
          if (res.datas.status === 2) {
            this.handlePaySuccess()
          } else {
            // 否则创建支付订单
            this.handleCreatePay()
          }
        } else {
          this.$message.error(res.message || '创建订单失败')
        }
      }).catch((err) => {
        console.error('创建订单失败:', err)
        this.$message.error('创建订单失败')
      })
    },

    // 创建支付
    handleCreatePay() {
      let URL = process.env.HOST + '/api/storage/order/createPay'
      
      // 创建FormData对象
      const formData = new FormData()
      formData.append('orderId', this.orderId)
      formData.append('payType', this.payMethod)

      let headers = {
        'Authorization': EUY.GetStorage('login_status').tokenId
      }

      this.AJAX.post(URL, headers, formData).then((res) => {
        if (res.code === 10000) {
          this.payUrl = res.datas.payUrl
          this.orderId = res.datas.orderId
          this.showPayDialog = true
        } else {
          this.$message.error(res.message || '创建支付订单失败')
        }
      }).catch((error) => {
        console.error('创建支付订单失败:', error.message)
        this.$message.error('创建支付订单失败')
      })
    },

    // 支付成功
    handlePaySuccess() {
      // 获取当前选中的会员等级信息
      const currentLevel = this.vipLevels.find(level => level.id === this.selectedVipId)
      if (!currentLevel) return

      // 构建提示消息
      let message = this.isUpgrade(currentLevel) ? 
        `恭喜，您已成功升级为${currentLevel.name}` :
        `恭喜，您已开通${currentLevel.name}`

      // 显示成功对话框
      this.$confirm(message, '支付成功', {
        confirmButtonText: '确定',
        showCancelButton: false,
        type: 'success',
        center: true
      }).then(() => {
        this.handleClose()
        // 刷新整个页面
        window.location.reload()
      })
    },

    // 取消支付
    handlePayCancel() {
      this.$message.info('如遇支付问题，请联系客服')
    },
    timestamp(time) {
      return new Date(time * 1000).toLocaleDateString('zh-CN', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    },
    // 获取时间单位
    getTimeUnit(level) {
      // 根据付费周期返回对应的时间单位
      if(level.productValidType === 1) {
        return '天'
      } else if (level.productValidType === 2) {
        return '月'
      } else {
        return '年'
      }
    },
    // 获取会员商品列表
    handleGetVipGoods() {
      let URL = process.env.HOST + '/api/storage/order/listGoods'
      let token = EUY.GetStorage('login_status').tokenId
      let headers = {
        'Authorization': token
      }
      let params = {
        goodsType: 1
      }

      this.AJAX.get(URL, headers, params).then((data) => {
        if (data.code === 10000) {
          this.vipLevels = data.datas.rows.map(item => ({
            type: item.productType,
            name: item.name,
            level: item.productNo,
            price: item.price,
            features: this.parseDesc(item.desc),
            id: item.id,
            productValidType: item.productValidType // 添加有效期类型
          }))
          
          // 默认选中月度
          this.selectPaymentCycle('monthly')
        } else {
          this.$message.error(data.message || '获取商品列表失败')
        }
      }).catch((err) => {
        console.error('获取商品列表失败:', err)
        this.$message.error('获取商品列表失败')
      }).finally(() => {
        this.loading = false
      })
    },
    // 获取充值商品列表
    handleGetRechargeGoods() {
      this.loading = true
      let URL = process.env.HOST + '/api/storage/order/listGoods'
      let token = EUY.GetStorage('login_status').tokenId
      let headers = {
        'Authorization': token
      }
      let params = {
        goodsType: 3
      }

      this.AJAX.get(URL, headers, params).then((res) => {
        if (res.code === 10000) {
          this.rechargeList = res.datas.rows.map(item => ({
            id: item.id,
            name: item.name,
            price: item.price,
            features: this.parseDesc(item.desc)
          }))
          // 默认选中第一个套餐
          if (this.rechargeList.length > 0) {
            this.selectedPackageId = this.rechargeList[0].id
          }
        }
      }).catch((err) => {
        console.error('获取充值套餐失败:', err)
        this.$message.error('获取充值套餐失败')
      }).finally(() => {
        this.loading = false
      })
    },
    // 解析HTML格式的desc
    parseDesc(desc) {
      const parser = new DOMParser()
      const doc = parser.parseFromString(desc, 'text/html')
      const items = doc.querySelectorAll('li')
      return Array.from(items).map(item => item.textContent)
    },
    // 停止支付状态轮询
    stopCheckPayStatus() {
      if (this.payStatusTimer) {
        clearInterval(this.payStatusTimer)
        this.payStatusTimer = null
      }
    },
    isUpgrade(level) {
      return this.identity.viplevel > 0 && !this.isExpired && level.level > this.identity.viplevel;
    },
  },
  // 组件销毁时清除定时器
  beforeDestroy() {
    this.stopCheckPayStatus()
  },
  // 组件隐藏时清除定时器
  deactivated() {
    this.stopCheckPayStatus()
  }
}
</script>

<style lang="stylus" scoped>  
// Dialog body样式优化
.vip-dialog ::v-deep .el-dialog__body
  padding-top 10px

// Tab切换器样式
.tab-switcher
  display flex
  margin-bottom 12px
  border-bottom 1px solid #e4e7ed
  .tab-item
    padding 8px 20px
    cursor pointer
    border-bottom 2px solid transparent
    transition all 0.3s
    display flex
    align-items center
    gap 6px
    font-size 14px
    color #606266
    &.active
      color #409EFF
      border-bottom-color #409EFF
    &:hover
      color #409EFF
    i
      font-size 14px

// Tab内容容器
.tab-content
  min-height 300px

.vip-container
  .payment-cycle
    margin-bottom 15px
    .cycle-title
      font-size 14px
      font-weight 600
      margin-bottom 10px
      color #303030
    .cycle-options
      display flex
      gap 12px
      .cycle-option
        padding 6px 16px
        border 1px solid #e4e7ed
        border-radius 4px
        cursor pointer
        transition all 0.3s
        font-size 13px
        &.active
          border-color #409EFF
          background-color #ecf5ff
          color #409EFF
  .vip-levels
    display flex
    justify-content space-around
    margin 12px 0 15px 0
    .vip-level-card
      position relative
      width 260px
      padding 15px
      border 1px solid #dcdfe6
      border-radius 4px
      cursor pointer
      transition all 0.3s
      &.disabled
        cursor not-allowed
        opacity 0.8
        &:hover
          transform none
          box-shadow none
      &:hover:not(.disabled)
        transform translateY(-3px)
        box-shadow 0 2px 8px 0 rgba(0,0,0,.08)
      &.active:not(.disabled)
        border-color #409eff
        box-shadow 0 2px 8px 0 rgba(0,0,0,.08)
      .current-level-tag
        position absolute
        top 8px
        right 8px
        background-color #409eff
        color white
        padding 2px 6px
        border-radius 10px
        font-size 11px
      .level-header
        font-size 16px
        font-weight 600
        margin-bottom 8px
        color #303030

      .level-price
        font-size 20px
        color #f56c6c
        margin-bottom 12px
        font-weight 600

      .level-features
        font-size 12px
        color #666666
        line-height 1.3

        > div
          margin-bottom 4px

  .payment-methods
    margin-bottom 20px

    .payment-title
      font-size 14px
      font-weight 600
      margin-bottom 10px
      color #303030

    .payment-options
      display flex
      gap 12px

      .payment-option
        display flex
        align-items center
        padding 8px 16px
        border 1px solid #e4e7ed
        border-radius 4px
        cursor pointer
        transition all 0.3s

        &.active
          border-color #409EFF
          background-color #ecf5ff

        img
          width 80px
          height 24px
          margin-right 8px

  .payment-action
    text-align center
    margin-top 15px

    .el-button
      width 180px
      height 36px

// 充值容器样式
.recharge-container
  .recharge-packages
    display flex
    flex-wrap wrap
    gap 15px
    margin-bottom 20px
    .package-card
      position relative
      width 260px
      padding 15px
      border 1px solid #dcdfe6
      border-radius 4px
      cursor pointer
      transition all 0.3s
      &:hover
        transform translateY(-3px)
        box-shadow 0 2px 8px 0 rgba(0,0,0,.08)
      &.active
        border-color #409eff
        box-shadow 0 2px 8px 0 rgba(0,0,0,.08)
      .level-header
        font-size 16px
        font-weight 600
        margin-bottom 8px
        color #303030
      .level-price
        font-size 20px
        color #f56c6c
        margin-bottom 12px
        font-weight 600
      .level-features
        font-size 12px
        color #666666
        line-height 1.3
        > div
          margin-bottom 4px
  .payment-methods
    margin-bottom 20px
    .payment-title
      font-size 14px
      font-weight 600
      margin-bottom 10px
      color #303030
    .payment-options
      display flex
      gap 12px
      .payment-option
        display flex
        align-items center
        padding 8px 16px
        border 1px solid #e4e7ed
        border-radius 4px
        cursor pointer
        transition all 0.3s
        &.active
          border-color #409EFF
          background-color #ecf5ff
        img
          width 80px
          height 24px
          margin-right 8px
  .payment-action
    text-align center
    margin-top 15px
    .el-button
      width 180px
      height 36px

.vip-title
  padding: 15px 20px
  display: flex
  align-items: center
  border-bottom: 1px solid #f0f0f0
  background: #fafafa
  .title-container
    display: flex
    flex-direction: column
    gap: 4px
    .title
      font-size: 18px
      font-weight: 600
      color: #303030
      font-family: PingFangSC-Semibold, PingFang SC
      line-height: 1.2
      margin: 0
    .subtitle
      font-size: 13px
      color: #999999
      font-family: PingFangSC-Regular, PingFang SC
      line-height: 1.3
      margin: 0

.mask-export-tips
  position: fixed
  top: 0
  left: 0
  width: 100%
  height: 100%
  background: rgba(0, 0, 0, 0.5)
  z-index: 2000
  display: flex
  justify-content: center
  align-items: center

  .export-tips
    background: #fff
    border-radius 4px
    padding: 20px
    width: 400px

    .tips-title
      font-size: 18px
      font-weight: bold
      margin-bottom: 20px
      text-align: center

    .tips-content
      margin-bottom: 20px
      p
        margin: 10px 0
        color: #666

    .tips-buttons
      display: flex
      justify-content: center
      gap: 20px

.pay-dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  
  .pay-dialog-mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
  }
  
  .pay-dialog-content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    border-radius: 4px;
    overflow: hidden;
  }
  
  .pay-dialog-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 20px;
    border-bottom: 1px solid #eee;
    
    .close-btn {
      cursor: pointer;
      font-size: 20px;
      color: #999;
      
      &:hover {
        color: #666;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// VipMember.vue?7a3699df